/**
 * @flow
 * @relayHash 97075c5f5dd548b133960d796666cce8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type List_suggestions$ref = any;
type LocalContainer_suggestions$ref = any;
type SimpleList_suggestions$ref = any;
export type ChangerComponentQueryVariables = {|
  orgId: string,
  name?: ?string,
|};
export type ChangerComponentQueryResponse = {|
  +authorizedSuborgs: $ReadOnlyArray<{|
    +$fragmentRefs: SimpleList_suggestions$ref & LocalContainer_suggestions$ref & List_suggestions$ref
  |}>
|};
export type ChangerComponentQuery = {|
  variables: ChangerComponentQueryVariables,
  response: ChangerComponentQueryResponse,
|};
*/


/*
query ChangerComponentQuery(
  $orgId: ID!
  $name: String
) {
  authorizedSuborgs(orgId: $orgId, name: $name) {
    ...SimpleList_suggestions
    ...LocalContainer_suggestions
    ...List_suggestions
    id
  }
}

fragment SimpleList_suggestions on PicklistInterface {
  region
  ...ListItem_item
}

fragment LocalContainer_suggestions on PicklistInterface {
  id
  name
  ...List_suggestions
  ...SimpleList_suggestions
}

fragment List_suggestions on PicklistInterface {
  ...ListUnit_item
}

fragment ListUnit_item on PicklistInterface {
  id
  name
}

fragment ListItem_item on PicklistInterface {
  id
  name
  region
  marketerEmails
  approvalRequired
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "orgId"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ChangerComponentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedSuborgs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Suborg",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SimpleList_suggestions",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "LocalContainer_suggestions",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "List_suggestions",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ChangerComponentQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedSuborgs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Suborg",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "region",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "marketerEmails",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "approvalRequired",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ChangerComponentQuery",
    "id": null,
    "text": "query ChangerComponentQuery(\n  $orgId: ID!\n  $name: String\n) {\n  authorizedSuborgs(orgId: $orgId, name: $name) {\n    ...SimpleList_suggestions\n    ...LocalContainer_suggestions\n    ...List_suggestions\n    id\n  }\n}\n\nfragment SimpleList_suggestions on PicklistInterface {\n  region\n  ...ListItem_item\n}\n\nfragment LocalContainer_suggestions on PicklistInterface {\n  id\n  name\n  ...List_suggestions\n  ...SimpleList_suggestions\n}\n\nfragment List_suggestions on PicklistInterface {\n  ...ListUnit_item\n}\n\nfragment ListUnit_item on PicklistInterface {\n  id\n  name\n}\n\nfragment ListItem_item on PicklistInterface {\n  id\n  name\n  region\n  marketerEmails\n  approvalRequired\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '00ce7c1d3a7384e7de6f44fc06d41836';
module.exports = node;
